import { connect } from "react-redux";
import { Col, Row } from "react-bootstrap";

import { systemActions } from "../../../../redux/actions";
import { PRODUCT_TYPES_ENUMS } from "../../../../system/globalEnums";
import {
  LogoImageReplaceIcon,
  PricechartingIcon,
} from "../../../../assets/icons/iconsProvider";
import PricechartingImage from "../../../../assets/images/PricechartingImage.png";
import {
  buttonNameConstants,
  buttonTypeConstants,
  inventoryConstants,
  NETWORK_AVERAGE_PRICE_TYPES,
} from "../../../../constants";
import {
  Button,
  NetworkAveragePriceSelect,
  ProductTagList,
  SkuToolTip,
} from "../../../../shared/components";
import {
  getProductImage,
  getDisplayProductTagCount,
  iShowTcgPlayerButtonLogo,
} from "../../../../shared/utilities/inventoryUtility";
import {
  convertToUsd,
  handleBeautifyMarketPrice,
  handleUploadProductImage,
  handleViewEbaySales,
  handleViewTCGPlayer,
  isMarketPriceHigh,
  onSelectTagsChange,
  formatCurrency,
  stringToSlug,
} from "../../../../shared/utility";
import ProductImageCard from "../../../../shared/components/productDetailCard/ProductImageCard";

const EditInventoryLeftColumn = (props) => {
  const {
    // parent component states
    state,
    values,
    productType,
    selectedTags,
    isCustomItem,
    setShowIframe,
    setProductUrl,
    hiddenFileInput,
    setSelectedTags,
    productTagsList,
    productCondition,
    productDataObject,
    setProductDataObject,
    // redux states
    productTags,
    activateSpinner,
    deactivateSpinner,
    priceChartingProductInfo,
    currentStore,
  } = props;

  const handleReplaceButtonClick = () => {
    hiddenFileInput.current.click();
  };

  return (
    <Col md={5} sm={12} className="edit-invetory-right mt-4 mt-md-0">
      <Row className="right-container m-0 p-0">
        <Row className="m-0 completeBoxDiv">
          <Col
            md={9}
            className="px-0 d-flex flex-column justify-content-center gap-3"
          >
            <p className="para-Text mb-0 text-break">
              {state?.data?.product_name}
            </p>
            <div className="p-0 d-flex flex-wrap gap-2">
              <span className="skitchin-Items">
                {state?.data?.category_name}
              </span>
              {state?.data?.subcategory && (
                <span className="skitchin-Items">
                  {state?.data?.subcategory}
                </span>
              )}
            </div>
            <span className="complete-number mt-0 d-flex align-items-center gap-2">
              SKU:
              <SkuToolTip sku={state?.data?.sku} />
            </span>
          </Col>
          <Col md={3}>
            <div className="add-inventory-product-image edit-inventory-product-image">
              <ProductImageCard src={getProductImage(productDataObject)} />
              <input
                type="file"
                className="d-none"
                accept=".png, .jpg, .jpeg"
                onChange={(e) =>
                  handleUploadProductImage(
                    e,
                    activateSpinner,
                    deactivateSpinner,
                    productDataObject,
                    setProductDataObject
                  )
                }
                ref={hiddenFileInput}
              />
              <button
                onClick={handleReplaceButtonClick}
                type="button"
                className="replace-logo-button"
              >
                <LogoImageReplaceIcon className="replace-icon" />
              </button>
            </div>
          </Col>

          {/* <p className="complete-box">{state?.data?.price?.type}</p> */}
        </Row>
        <Row className="m-0  market-price-div">
          <Row className="d-flex m-0 p-0 justify-content-between align-items-center detail-div pb-4">
            <Col className="price-market-text" md={6}>
              Market Price:
            </Col>
            <Col
              className={`price-market-amount d-flex justify-content-end align-items-center gap-3 ${
                isMarketPriceHigh(
                  handleBeautifyMarketPrice(productDataObject),
                  values.unitsellprice,
                  productTags,
                  selectedTags
                ) && values.unitsellprice
                  ? "text-danger"
                  : ""
              }`}
              md={6}
            >
              {!isCustomItem &&
                productType === PRODUCT_TYPES_ENUMS.VIDEO_GAME && (
                  <ProductImageCard
                    alt="Product preview"
                    src={PricechartingImage}
                    className="pricecharting-icon"
                  />
                )}
              {formatCurrency(handleBeautifyMarketPrice(productDataObject))}
            </Col>
          </Row>
          <Row className="d-flex m-0 p-0 mt-2 justify-content-between pt-3">
            <Col className="suggest-text " md={6}>
              Suggested Sell Price:
            </Col>
            <Col className="suggest-amount d-flex justify-content-end" md={6}>
              {formatCurrency(
                convertToUsd(productDataObject?.suggestedSellPrice ?? 0)
              )}
            </Col>
          </Row>
          <Col className="p-0 mt-3 d-flex gap-2 ms-auto">
            {state?.data?.apiSource === inventoryConstants.PRICECHARTING_API ? (
              <>
                <Button
                  handleClick={() => {
                    handleViewEbaySales(
                      state?.data?.product_name,
                      state?.data?.category_name,
                      state?.data?.subcategory
                    );
                  }}
                  type="button"
                  label={buttonNameConstants.EBAY_SALES}
                  buttonType={buttonTypeConstants.GREEN_BUTTON}
                  className="w-100"
                ></Button>
                <Button
                  type="button"
                  handleClick={() => {
                    setProductUrl(
                      `${
                        process.env.REACT_APP_PRICECHARTING_IFRAME_URL
                      }${stringToSlug(
                        state?.data?.category_name
                      )}/${stringToSlug(state?.data?.product_name)}`
                    );
                    setShowIframe(true);
                  }}
                  label={buttonNameConstants.PRICE_CHARTING}
                  buttonType={buttonTypeConstants.BLUE_BUTTON}
                  className="w-100"
                  IconImage={PricechartingIcon}
                ></Button>
              </>
            ) : (
              iShowTcgPlayerButtonLogo(
                priceChartingProductInfo?.productMetaData?.sourceApi ||
                  productDataObject?.apiSource,
                currentStore
              ) && (
                <Button
                  type="button"
                  handleClick={() => {
                    handleViewTCGPlayer(productDataObject);
                  }}
                  label={buttonNameConstants.VIEW_TCG_PLAYER}
                  buttonType={buttonTypeConstants.BLUE_BUTTON}
                  className="ms-auto w-50"
                  isDisabled={!productDataObject?.tcgPlayerUrl}
                ></Button>
              )
            )}
          </Col>
        </Row>
        <Row className="m-0 product-stats product-stats-con-height container-scrollbar">
          <Col className="product-stats-text">Your Product Stats</Col>

          <div className="detail-div">
            <p>Total Units Sold:</p>
            <span>{state?.data?.price?.totalUnitsSold}</span>
          </div>
          <div className="detail-div">
            <p>Average Cost of Goods:</p>
            <span>{formatCurrency(state?.data?.price?.averageBuyPrice)}</span>
          </div>
          <div className="detail-div">
            <p>Average Sold Price:</p>
            <span>{formatCurrency(state?.data?.price?.averageSellPrice)}</span>
          </div>
          <div className="detail-div">
            <p>Max Trade:</p>
            <span>
              {state?.data?.price?.maxTrade
                ? formatCurrency(state?.data?.price?.maxTrade)
                : " -"}
            </span>
          </div>
          <div className="detail-div">
            <p>Max Cash:</p>
            <span>
              {state?.data?.price?.maxCash
                ? formatCurrency(state?.data?.price?.maxCash)
                : " -"}
            </span>
          </div>
          <NetworkAveragePriceSelect
            isModalChild={false}
            networkAverageBuySellPrices={
              productDataObject.networkAverageBuySellPrices
            }
            networkAveragePriceType={NETWORK_AVERAGE_PRICE_TYPES.SELL_PRICE}
          />
          <NetworkAveragePriceSelect
            isModalChild={false}
            networkAverageBuySellPrices={
              productDataObject.networkAverageBuySellPrices
            }
            networkAveragePriceType={NETWORK_AVERAGE_PRICE_TYPES.BUY_PRICE}
          />
        </Row>
      </Row>
      <Row className="m-0 w-100 edit-invetory-left mt-3">
        <div className="pricing-Div">
          <Col md={12} className="pricing-Text p-0">
            Tags({getDisplayProductTagCount(selectedTags)}):
          </Col>
          <Col className="p-0">
            <ProductTagList
              isShowLabel={false}
              className={"d-flex flex-column align-items-start mt-3"}
              productCondition={productCondition}
              tagsList={productTagsList || []}
              suggestedArrayList={productTags}
              onSelectTagsChange={(selectedTags) => {
                onSelectTagsChange(
                  selectedTags,
                  setSelectedTags,
                  productDataObject,
                  setProductDataObject,
                  priceChartingProductInfo,
                  productCondition,
                  productType
                );
              }}
              productDetail={{
                ...state?.data,
                tags: state?.data.tags.map((tag, index) => ({
                  id: index,
                  label: tag,
                  selected: true,
                })),
              }}
            />
          </Col>
        </div>
      </Row>
    </Col>
  );
};

const mapStateToProps = (state) => ({
  productTags: state.inventory.productTags,
  priceChartingProductInfo: state.inventory.priceChartingProductInfo,
  currentStore: state.store.currentStore,
});
const mapDispatchToProps = (dispatch) => ({
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditInventoryLeftColumn);
